import { render, staticRenderFns } from "./TheConfirmationLogoutModal.vue?vue&type=template&id=4894801c"
import script from "./TheConfirmationLogoutModal.vue?vue&type=script&lang=js"
export * from "./TheConfirmationLogoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports